














import { Component, Prop, Vue } from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';

@Component({
  components: {
    apexchart: VueApexCharts,
  },
})
export default class GoalRadialCard extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) subtitle!: string;

  chartSeries = [80, 50];

  chartOptions: ApexOptions = {
    colors: ['#28C76F'],
    chart: {
      type: 'radialBar',
      height: 350,
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: '25%',
        },
        track: {
          margin: 20,
        },
        dataLabels: {
          name: {},
          value: {},
          total: {
            show: true,
            fontSize: '1rem',
            label: 'Comments',
            formatter: function (w) {
              return '80%';
            },
          },
        },
      },
    },
    grid: {
      padding: {
        top: -35,
        bottom: -30,
      },
    },
    legend: {
      show: true,
      position: 'bottom',
    },
    stroke: {
      lineCap: 'round',
    },
    labels: ['Comments', 'Replies'],
  };
}
